"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/main.ts
var main_exports = {};
__export(main_exports, {
  GenZKPError: () => GenZKPError,
  GenericError: () => GenericError,
  ImportZkCertError: () => ImportZkCertError,
  RpcMethods: () => RpcMethods,
  RpcResponseErr: () => RpcResponseErr,
  RpcResponseMsg: () => RpcResponseMsg,
  URLUpdateError: () => URLUpdateError,
  ZkCertStandard: () => import_galactica_types.ZkCertStandard,
  clearStorage: () => clearStorage,
  connectSnap: () => connectSnap,
  deleteZkCert: () => deleteZkCert,
  exportZkCert: () => exportZkCert,
  generateZKProof: () => generateZKProof,
  getHolderCommitment: () => getHolderCommitment,
  getSnap: () => getSnap,
  getSnaps: () => getSnaps,
  getZkCertHashes: () => getZkCertHashes,
  getZkStorageHashes: () => getZkStorageHashes,
  importZkCert: () => importZkCert,
  isLocalSnap: () => isLocalSnap,
  listZkCerts: () => listZkCerts,
  sdkConfig: () => sdkConfig,
  updateMerkleProof: () => updateMerkleProof,
  updateMerkleProofURL: () => updateMerkleProofURL
});
module.exports = __toCommonJS(main_exports);

// src/api/rpcEnums.ts
var RpcMethods = /* @__PURE__ */ ((RpcMethods2) => {
  RpcMethods2["GetHolderCommitment"] = "getHolderCommitment";
  RpcMethods2["GenZkCertProof"] = "genZkCertProof";
  RpcMethods2["ClearStorage"] = "clearStorage";
  RpcMethods2["ImportZkCert"] = "importZkCert";
  RpcMethods2["ExportZkCert"] = "exportZkCert";
  RpcMethods2["ListZkCerts"] = "listZkCerts";
  RpcMethods2["GetZkCertStorageHashes"] = "getZkCertStorageHashes";
  RpcMethods2["GetZkCertHash"] = "getZkCertHashes";
  RpcMethods2["UpdateMerkleProof"] = "updateMerkleProof";
  RpcMethods2["UpdateMerkleProofURL"] = "updateMerkleProofURL";
  RpcMethods2["DeleteZkCert"] = "deleteZkCert";
  return RpcMethods2;
})(RpcMethods || {});
var RpcResponseErr = /* @__PURE__ */ ((RpcResponseErr2) => {
  RpcResponseErr2["RejectedConfirm"] = "User rejected confirmation.";
  RpcResponseErr2["UnknownMethod"] = "Method not found.";
  RpcResponseErr2["MissingHolder"] = "No holders imported. Please import a holding address first.";
  RpcResponseErr2["RejectedConnect"] = "User rejected the request.";
  RpcResponseErr2["RejectedSignature"] = "User denied message signature.";
  RpcResponseErr2["RejectedSelect"] = "User did not choose a zkCertificate.";
  return RpcResponseErr2;
})(RpcResponseErr || {});

// src/config/index.ts
var sdkConfig = {
  defaultSnapOrigin: "npm:@galactica-net/snap",
  defaultSnapVersion: "0.7.1",
  contracts: {
    41238: {
      kycGuardianWhitelist: "0xB95314E42d8Da05b1D805039F7b96e3935584543",
      zkKycRegistry: "0x0415E990e55071F0d448F87CD170528C7783A484",
      verificationSbt: "0x062DaB74A2709EC730FE11b3d9C00033B0FBAf92",
      exampleZkKycAgeProof: "0x1554B2D7422941Be9903040d9946da60d9f2bC3C",
      exampleZkpVerifier: "0xA437DFE87F9096e52E4dEcAA7cfc14d82A5aE07e",
      exampleDapp: "0xBD2FAA4835E1A462Ea4FDA39352F24C58e237e2a",
      exampleInstitution: [
        "0x5E523B1c7c04eB971D3b851C82d3935b91fb4b3e",
        "0xcc433436B6c01142EC9B95a1b80B3734CD4849f3",
        "0x8d5ebACB647aea8a76082A36C93997765A50AF0E"
      ],
      exampleZkKyc: "0xD95efF72F06079DEcE33b18B165fc3A7a4bdc1fD",
      repeatableZkpTest: "0xa99fcD678D985fB2ac8aD3fE913aED88705A44fc",
      devnetGuardian: "0x71d80ea7744302E5b1cFD61a7a26153FF221ca9E"
    },
    9302: {
      kycGuardianWhitelist: "0x8Db9C6d860694d6bF151c961E2A55d3F51e2D138",
      zkKycRegistry: "0x85032c035494324f62A5AfE2507d5427dFd72e76",
      verificationSbt: "0xc6d55A0F0f7b6b5a2418963AC35d312535F20D67",
      exampleZkKycAgeProof: "0x1fA98f7B53dCCC93f37243e2069781225dE442f3",
      exampleZkpVerifier: "0xCF0EA7C6b77c2ef8EbCD8854671f35f092Db7A5E",
      exampleDapp: "0x9a17084bb850FBF1431BBEC6e7b316F374E2b49c",
      exampleInstitution: [
        "0xb8B1720908717E585d98A502c0A9743c06DC96E5",
        "0xB9e011AD8849aeA1F2d9d30582987645bFAE3729",
        "0xC29A1e7aD2f3B938a1668d4e2702801BF21CE32C"
      ],
      exampleZkKyc: "0x6989febF9623FAD3c5FC25B84e0b8F2F0d9a68f0",
      repeatableZkpTest: "0x4262b70fDBBF05C48a0887472b89988B84C98564",
      devnetGuardian: "0xEcE0BBeB552710718A1bD5E028443ff9B2f26BE5"
    }
  }
};

// src/utils/invoke-snap.ts
var invokeSnap = async (request, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  var _a;
  if (!window.ethereum) {
    throw new Error("window.ethereum is undefined");
  }
  return (_a = window.ethereum) == null ? void 0 : _a.request({
    method: "wallet_invokeSnap",
    params: {
      snapId: snapOrigin,
      request
    }
  });
};

// src/api/clear-storage.ts
var clearStorage = async (snapOrigin = sdkConfig.defaultSnapOrigin) => {
  return await invokeSnap({ method: "clearStorage" /* ClearStorage */ }, snapOrigin);
};

// src/api/delete-zk-cert.ts
var deleteZkCert = async (params, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "deleteZkCert" /* DeleteZkCert */,
      params
    },
    snapOrigin
  );
  return response;
};

// src/api/export-zk-cert.ts
var exportZkCert = async (params, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "exportZkCert" /* ExportZkCert */,
      params
    },
    snapOrigin
  );
  return response;
};

// src/api/error.ts
var GalacticaErrorBase = class extends Error {
  constructor({ name, message }) {
    super();
    this.name = name;
    this.message = message;
  }
};
var GenericError = class extends GalacticaErrorBase {
};

// src/api/gen-zk-cert-proof.ts
var GenZKPError = class extends GalacticaErrorBase {
};
var generateZKProof = async (params, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "genZkCertProof" /* GenZkCertProof */,
      params
    },
    snapOrigin
  );
  return response;
};

// src/api/get-holder-commitment.ts
var getHolderCommitment = async (snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "getHolderCommitment" /* GetHolderCommitment */
    },
    snapOrigin
  );
  return response;
};

// src/api/get-zk-cert-hashes.ts
var getZkCertHashes = async (snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    { method: "getZkCertHashes" /* GetZkCertHash */ },
    snapOrigin
  );
  return response;
};

// src/api/get-zk-storage-hashes.ts
var getZkStorageHashes = async (snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "getZkCertStorageHashes" /* GetZkCertStorageHashes */
    },
    snapOrigin
  );
  return response;
};

// src/api/import-zk-cert.ts
var ImportZkCertError = class extends GalacticaErrorBase {
};
var importZkCert = async (importParams, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "importZkCert" /* ImportZkCert */,
      params: importParams
    },
    snapOrigin
  );
  return response;
};

// src/api/list-zk-certs.ts
var listZkCerts = async (params, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "listZkCerts" /* ListZkCerts */,
      params
    },
    snapOrigin
  );
  return response;
};

// src/api/update-merkle-proof.ts
var updateMerkleProof = async (merkleUpdate, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "updateMerkleProof" /* UpdateMerkleProof */,
      params: merkleUpdate
    },
    snapOrigin
  );
  return response;
};

// src/api/update-merkle-proof-url.ts
var URLUpdateError = class extends GalacticaErrorBase {
};
var updateMerkleProofURL = async (update, snapOrigin = sdkConfig.defaultSnapOrigin) => {
  const response = await invokeSnap(
    {
      method: "updateMerkleProofURL" /* UpdateMerkleProofURL */,
      params: update
    },
    snapOrigin
  );
  return response;
};

// src/api/types.ts
var import_galactica_types = require("@galactica-net/galactica-types");

// src/api/snap.ts
var getSnaps = async () => {
  return await window.ethereum.request({
    method: "wallet_getSnaps"
  });
};
var connectSnap = async (snapId = sdkConfig.defaultSnapOrigin, params = { version: void 0 }) => {
  console.log("Connecting to snap", snapId, params);
  const res = await window.ethereum.request({
    method: "wallet_requestSnaps",
    params: {
      [snapId]: __spreadValues({}, params)
    }
  });
  console.log(JSON.stringify(res, null, 2));
};
var getSnap = async (snapId = sdkConfig.defaultSnapOrigin, version) => {
  try {
    const snaps = await getSnaps();
    return Object.values(snaps).find(
      (snap) => snap.id === snapId && (!version || snap.version === version)
    );
  } catch (error) {
    console.log("Failed to obtain installed snap", error);
    return void 0;
  }
};
var isLocalSnap = (snapId) => snapId.startsWith("local:");

// src/api/confirmation.ts
var RpcResponseMsg = /* @__PURE__ */ ((RpcResponseMsg2) => {
  RpcResponseMsg2["StorageCleared"] = "zkCert storage cleared";
  RpcResponseMsg2["ZkCertImported"] = "zkCert added to storage";
  RpcResponseMsg2["MerkleProofsUpdated"] = "Updated Merkle proofs";
  RpcResponseMsg2["ZkCertAlreadyImported"] = "This zkCert has already been imported. Skipping it.";
  RpcResponseMsg2["ZkCertDeleted"] = "Deleted zkCert.";
  return RpcResponseMsg2;
})(RpcResponseMsg || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  GenZKPError,
  GenericError,
  ImportZkCertError,
  RpcMethods,
  RpcResponseErr,
  RpcResponseMsg,
  URLUpdateError,
  ZkCertStandard,
  clearStorage,
  connectSnap,
  deleteZkCert,
  exportZkCert,
  generateZKProof,
  getHolderCommitment,
  getSnap,
  getSnaps,
  getZkCertHashes,
  getZkStorageHashes,
  importZkCert,
  isLocalSnap,
  listZkCerts,
  sdkConfig,
  updateMerkleProof,
  updateMerkleProofURL
});
//# sourceMappingURL=main.js.map